import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { AuthLayout } from '../components/AppShell.js';
import { Button, InlineAlert, Spinner } from '../components/ui.js';
import { api } from '../lib/api.js';
import { errorMessage } from '../lib/session.js';

/** Confirmarea adresei de email, la click pe linkul din email. */
export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [state, setState] = useState<'loading' | 'ok' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setState('error');
      setMessage('Linkul nu conține tokenul de confirmare.');
      return;
    }
    let active = true;
    api
      .post<{ verified: boolean }>('/auth/email/verify', { token })
      .then(() => {
        if (active) setState('ok');
      })
      .catch((error) => {
        if (!active) return;
        setState('error');
        setMessage(errorMessage(error));
      });
    return () => {
      active = false;
    };
  }, [token]);

  return (
    <AuthLayout>
      <div className="w-full max-w-sm">
        <h1 className="font-display text-display-m text-ink-950">Confirmarea emailului</h1>
        <div className="mt-6">
          {state === 'loading' ? (
            <div className="flex items-center gap-3 text-ink-600">
              <Spinner size={18} />
              <span className="text-body-s">Verificăm linkul…</span>
            </div>
          ) : null}

          {state === 'ok' ? (
            <InlineAlert tone="success" title="Email confirmat">
              Gata! Adresa ta este confirmată, iar notificările de securitate ajung acum la tine.
            </InlineAlert>
          ) : null}

          {state === 'error' ? (
            <InlineAlert tone="danger" title="Link invalid sau expirat">
              {message}
            </InlineAlert>
          ) : null}
        </div>

        <div className="mt-6 flex gap-2">
          <Link to="/app">
            <Button variant={state === 'ok' ? 'primary' : 'secondary'}>Mergi în dashboard</Button>
          </Link>
        </div>
      </div>
    </AuthLayout>
  );
}
